import { render, staticRenderFns } from "./PictureFrame.vue?vue&type=template&id=146af924&"
import script from "./PictureFrame.vue?vue&type=script&lang=js&"
export * from "./PictureFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports